const categories = [
	{
		_id: '66d8b83f6e195ee1d5e0563d',
		parentId: 0,
		name: 'Birth Kits',
		sortOrder: 12,
		defaultProductSort: 'alpha_asc',
		url: {
			path: '/birth-kits/',
			isCustomized: false,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/b/category-description-image-birth-kit__44108.jpg',
		bcId: 10,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e0563d',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e05680',
				parentId: 10,
				name: 'Custom Birth Kits by Midwife',
				sortOrder: 1,
				defaultProductSort: 'alpha_asc',
				url: {
					path: '/midwife-birth-kits/',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/r/midwife%20birth%20kits%20collage__06227.png',
				bcId: 89,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05680',
			},
			{
				_id: '66d8b83f6e195ee1d5e0568a',
				parentId: 10,
				name: 'Birth Kits by In His Hands',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/birth-kits-by-in-his-hands/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/g/ihh_bk_thumbnail__43643.jpeg',
				bcId: 100,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0568a',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e05641',
		parentId: 0,
		name: 'Birth Supplies',
		sortOrder: 13,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/birth-supplies/',
			isCustomized: false,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/category-description-image-birth-supplies__57544.jpg',
		bcId: 16,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e05641',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056c1',
				parentId: 16,
				name: 'Nutrition',
				sortOrder: 9,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/nutrition/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/i/motif%20category%20image-3__08264.png',
				bcId: 159,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056c1',
			},
			{
				_id: '66d8b83f6e195ee1d5e056c7',
				parentId: 16,
				name: 'Best Sellers',
				sortOrder: 12,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/best-sellers/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/untitled%20design%20%2812%29__42142.png',
				bcId: 165,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056c7',
			},
			{
				_id: '66d8b83f6e195ee1d5e05646',
				parentId: 16,
				name: 'Paper & Plastic ',
				sortOrder: 7,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/paper-plastic/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/y/6__87308.png',
				bcId: 23,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05646',
			},
			{
				_id: '66d8b83f6e195ee1d5e05640',
				parentId: 16,
				name: 'New',
				sortOrder: 13,
				defaultProductSort: 'newest',
				url: {
					path: '/New',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/untitled%20design-13__03367.png',
				bcId: 15,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05640',
			},
			{
				_id: '66d8b83f6e195ee1d5e05647',
				parentId: 16,
				name: 'Doppler & Exam Gel',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/lubrication-ultrasound-jelly/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/e/2__39288.png',
				bcId: 24,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05647',
			},
			{
				_id: '66d8b83f6e195ee1d5e05648',
				parentId: 16,
				name: 'Birth & Baby',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/birth-baby/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/t/9__12234.png',
				bcId: 25,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05648',
			},
			{
				_id: '66d8b83f6e195ee1d5e05649',
				parentId: 16,
				name: 'Postpartum Pads ',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/postpartum-pads/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/p/postpartem_pads_thumbnail__08956.jpeg',
				bcId: 30,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05649',
			},
			{
				_id: '66d8b83f6e195ee1d5e0564a',
				parentId: 16,
				name: 'Midwife Birth Bag',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/midwife-birth-bag/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/y/4__20838.png',
				bcId: 31,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0564a',
			},
			{
				_id: '66d8b83f6e195ee1d5e0564b',
				parentId: 16,
				name: 'Newborn Heel Lancets',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/lancets',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/1__35986.png',
				bcId: 32,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0564b',
			},
			{
				_id: '66d8b83f6e195ee1d5e0564c',
				parentId: 16,
				name: 'Thermometers',
				sortOrder: 11,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/thermometers/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/11__34400.png',
				bcId: 33,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0564c',
			},
			{
				_id: '66d8b83f6e195ee1d5e05684',
				parentId: 16,
				name: 'Underpads',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/underpads/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/b/3__45004.png',
				bcId: 94,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05684',
			},
			{
				_id: '66d8b83f6e195ee1d5e05671',
				parentId: 16,
				name: 'Antiseptics & Soaps',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/antiseptics-soaps/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/p/7__40437.png',
				bcId: 74,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05671',
			},
			{
				_id: '66d8b83f6e195ee1d5e05675',
				parentId: 16,
				name: 'Gloves',
				sortOrder: 10,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/gloves-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/8__05131.png',
				bcId: 78,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05675',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e0563f',
		parentId: 0,
		name: 'Water Birth ',
		sortOrder: 14,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/water-birth',
			isCustomized: true,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/p/category-description-image-water-birth__19302.jpg',
		bcId: 13,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e0563f',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056b3',
				parentId: 13,
				name: 'Earthside Pools',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earthside-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/h/earthside%20%281%29__01144.jpg',
				bcId: 145,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056b3',
			},
			{
				_id: '66d8b83f6e195ee1d5e056a2',
				parentId: 13,
				name: 'Complete Water Birth Packages',
				sortOrder: 10,
				defaultProductSort: 'price_asc',
				url: {
					path: '/birth-pool-packages/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/pool_kits_thumbnail__84355.jpeg',
				bcId: 128,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a2',
			},
			{
				_id: '66d8b83f6e195ee1d5e056c5',
				parentId: 13,
				name: 'Mia Via Pools',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mia-via-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/o/mia%20via%20pool__76171.jpg',
				bcId: 163,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056c5',
			},
			{
				_id: '66d8b83f6e195ee1d5e0568f',
				parentId: 13,
				name: 'Oasis Pools',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/oasis-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/h/oasis_pools_thumbnail__88210.jpeg',
				bcId: 105,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0568f',
			},
			{
				_id: '671fc9abb0bccbcb220439a6',
				parentId: 13,
				name: 'Tubina Wild Pools',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/tubina-wild-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/tubina_wild_thumbnail__16654.jpeg',
				bcId: 185,
				collection: 'categories',
				id: '671fc9abb0bccbcb220439a6',
			},
			{
				_id: '66d8b83f6e195ee1d5e056cc',
				parentId: 13,
				name: 'All Birth Pools',
				sortOrder: 9,
				defaultProductSort: 'alpha_asc',
				url: {
					path: '/all-birth-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/all%20pools%20__32534.jpg',
				bcId: 170,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056cc',
			},
			{
				_id: '66d8b83f6e195ee1d5e05663',
				parentId: 13,
				name: 'La Bassine Pools',
				sortOrder: 6,
				defaultProductSort: 'best_selling',
				url: {
					path: '/la-bassine-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/z/category-image-water-birth-la-bassine-pools__00062.jpg',
				bcId: 59,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05663',
			},
			{
				_id: '66d8b83f6e195ee1d5e05664',
				parentId: 13,
				name: 'Birth Pool Liners',
				sortOrder: 7,
				defaultProductSort: 'best_selling',
				url: {
					path: '/birth-pool-liners/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/category-image-water-birth-birth-pool-liners__62222.jpg',
				bcId: 60,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05664',
			},
			{
				_id: '66d8b83f6e195ee1d5e05689',
				parentId: 13,
				name: 'Birth Pool in a Box Pools',
				sortOrder: 1,
				defaultProductSort: 'newest',
				url: {
					path: '/BPIAB',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/category-image-water-birth-birth-pool-box-pools__58581.jpg',
				bcId: 99,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05689',
			},
			{
				_id: '66d8b83f6e195ee1d5e05665',
				parentId: 13,
				name: 'Water Birth Accessories ',
				sortOrder: 8,
				defaultProductSort: 'best_selling',
				url: {
					path: '/water-birth-accessories-/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/category-image-water-birth-accessories__17961.jpg',
				bcId: 61,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05665',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e0563e',
		parentId: 0,
		name: 'Natural',
		sortOrder: 16,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/herbal-natural/',
			isCustomized: true,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/category-description-image-herbal__78962.jpg',
		bcId: 12,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e0563e',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056a5',
				parentId: 12,
				name: 'Midwife Made Naturals',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/midwife-made-naturals-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/untitled%20design%20%2818%29__03234.png',
				bcId: 131,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a5',
			},
			{
				_id: '66d8b83f6e195ee1d5e056ab',
				parentId: 12,
				name: 'Motherlove',
				sortOrder: 12,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/motherlove/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/r/mother%20love%20category%20image__99264.png',
				bcId: 137,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056ab',
			},
			{
				_id: '66d8b83f6e195ee1d5e056a1',
				parentId: 12,
				name: 'Birth Song Botanicals ',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/birth-song-botanicals-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/bsb%20%20category%20image__38714.png',
				bcId: 127,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a1',
			},
			{
				_id: '66d8b83f6e195ee1d5e056b8',
				parentId: 12,
				name: 'Lavender Meadows Co',
				sortOrder: 10,
				defaultProductSort: 'alpha_asc',
				url: {
					path: '/lavender-meadows-co/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/lavender%20meadows%20co__82336.jpg',
				bcId: 150,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056b8',
			},
			{
				_id: '66d8b83f6e195ee1d5e05690',
				parentId: 12,
				name: 'Earthley Wellness',
				sortOrder: 7,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earthley-wellness/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/j/category-image-herbal-earthely-wellness__78779.jpg',
				bcId: 106,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05690',
			},
			{
				_id: '66d8b83f6e195ee1d5e05692',
				parentId: 12,
				name: 'Earth Mama',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earth-mama/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/category-image-herbal-earth%20mama__99507.jpg',
				bcId: 108,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05692',
			},
			{
				_id: '66d8b83f6e195ee1d5e05699',
				parentId: 12,
				name: 'Essential Oils',
				sortOrder: 18,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/essential-oils/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/essential-oils__61289.jpg',
				bcId: 116,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05699',
			},
			{
				_id: '66d8b83f6e195ee1d5e0569f',
				parentId: 12,
				name: 'Homeopathy',
				sortOrder: 17,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/homeopathy/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/homeopathy%20category%20image__92197.png',
				bcId: 124,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0569f',
			},
			{
				_id: '67297d5101431d64aa785a22',
				parentId: 12,
				name: 'Legendairy Milk',
				sortOrder: 0,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/legendairy-milk/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/brand%20logos-2__79458.png',
				bcId: 188,
				collection: 'categories',
				id: '67297d5101431d64aa785a22',
			},
			{
				_id: '670ebf1e858a1810195905c0',
				parentId: 12,
				name: 'Clean By Emmie',
				sortOrder: 9,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/clean-by-emmie/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/clean%20by%20emmie%20logo__29822.png',
				bcId: 172,
				collection: 'categories',
				id: '670ebf1e858a1810195905c0',
			},
			{
				_id: '66d8b83f6e195ee1d5e0565b',
				parentId: 12,
				name: 'Sitz Baths',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/after-birth-baths-and-herbal-powders/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/r/herbal%20tab__38086.png',
				bcId: 51,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0565b',
			},
			{
				_id: '66d8b83f6e195ee1d5e0565c',
				parentId: 12,
				name: "Mother's Herbal Tinctures",
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mothers-herbal/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/mothers-herbal__89064.png',
				bcId: 52,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0565c',
			},
			{
				_id: '66d8b83f6e195ee1d5e0565d',
				parentId: 12,
				name: 'WishGarden Herbal Tinctures',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/wishgarden-herbal-tinctures/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/p/category-image-herbal-wish-garden__05668.jpg',
				bcId: 53,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0565d',
			},
			{
				_id: '66d8b83f6e195ee1d5e0565e',
				parentId: 12,
				name: 'Natural Oils, Powders & Homeopathics',
				sortOrder: 15,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/natural-oils-powders-homeopathics/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/e/natural%20products%20%281%29__98803.png',
				bcId: 54,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0565e',
			},
			{
				_id: '66d8b83f6e195ee1d5e0565f',
				parentId: 12,
				name: 'Teas',
				sortOrder: 14,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/tea/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/y/category-image-herbal-teas__58335.jpg',
				bcId: 55,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0565f',
			},
			{
				_id: '66d8b83f6e195ee1d5e05660',
				parentId: 12,
				name: 'Intimate Solutions by Shonda Parker',
				sortOrder: 11,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/intimate-solutions/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/category-image-herbal-intimate-solutions__67415.jpg',
				bcId: 56,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05660',
			},
			{
				_id: '66d8b83f6e195ee1d5e05661',
				parentId: 12,
				name: 'Dry Herbs',
				sortOrder: 13,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/dry-herbs/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/d/category-image-herbal-dry-herbs__52110.jpg',
				bcId: 57,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05661',
			},
			{
				_id: '66d8b83f6e195ee1d5e05662',
				parentId: 12,
				name: 'Mountain Meadow Tinctures',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mountain-meadow-herbs/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/category-image-herbal-mountain-meadow__98810.jpg',
				bcId: 58,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05662',
			},
			{
				_id: '66d8b83f6e195ee1d5e0566e',
				parentId: 12,
				name: 'Supplements',
				sortOrder: 16,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/supplements/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/category-image-herbal-supplements__79240.jpg',
				bcId: 70,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0566e',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e05642',
		parentId: 0,
		name: 'For Midwives',
		sortOrder: 17,
		defaultProductSort: 'alpha_asc',
		url: {
			path: '/midwifery-supplies/',
			isCustomized: true,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/category-description-image-midwifery__12319.jpg',
		bcId: 17,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e05642',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056b5',
				parentId: 17,
				name: 'Amniotic Perforation',
				sortOrder: 15,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/amniotic-perforation/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/amniotic%20preforation__26338.jpg',
				bcId: 147,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056b5',
			},
			{
				_id: '66d8b83f6e195ee1d5e05698',
				parentId: 17,
				name: 'Personal Protective Equipment',
				sortOrder: 24,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/personal-protective-equipment/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/t/ppe-personal-protective-equipment__13559.png',
				bcId: 115,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05698',
			},
			{
				_id: '66d8b83f6e195ee1d5e0569d',
				parentId: 17,
				name: 'Catheters',
				sortOrder: 20,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/catheters/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/catheters__21475.jpg',
				bcId: 122,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0569d',
			},
			{
				_id: '66d8b83f6e195ee1d5e056a0',
				parentId: 17,
				name: 'Bulk Items',
				sortOrder: 23,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/bulk-items/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/a/bulk%20%20category%20image__09045.png',
				bcId: 126,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a0',
			},
			{
				_id: '67225a3e54c2430812acee9d',
				parentId: 17,
				name: 'Midwife Essentials',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/midwife-essentials/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/x/brand%20logos%20%282%29__77671.png',
				bcId: 186,
				collection: 'categories',
				id: '67225a3e54c2430812acee9d',
			},
			{
				_id: '68c4627123fe0b2faa061bfc',
				parentId: 17,
				name: 'For Birth Centers',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/for-birth-centers/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/2__04139.jpg',
				bcId: 199,
				collection: 'categories',
				id: '68c4627123fe0b2faa061bfc',
			},
			{
				_id: '68f10f329f8c3f1dd51f8b32',
				parentId: 17,
				name: 'Glucose Testing',
				sortOrder: 9,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/glucose-testing/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/r/5__81595.png',
				bcId: 200,
				collection: 'categories',
				id: '68f10f329f8c3f1dd51f8b32',
			},
			{
				_id: '66d8b83f6e195ee1d5e056c8',
				parentId: 17,
				name: 'Jaundice Phototherapy',
				sortOrder: 18,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/jaundice-phototherapy/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/w/jaundice%20phototherapy__94315.jpg',
				bcId: 166,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056c8',
			},
			{
				_id: '66d8b83f6e195ee1d5e056cb',
				parentId: 17,
				name: 'Doula Supplies',
				sortOrder: 14,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/doula-supplies/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/z/brand%20logos%20%281%29__23492.png',
				bcId: 169,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056cb',
			},
			{
				_id: '66d8b83f6e195ee1d5e05651',
				parentId: 17,
				name: 'I. V. Supplies',
				sortOrder: 13,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/i-v-supplies/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/category-image-midwifery-iv-supplies__31529.jpg',
				bcId: 39,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05651',
			},
			{
				_id: '66d8b83f6e195ee1d5e05652',
				parentId: 17,
				name: 'Instruments',
				sortOrder: 16,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/Instruments',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/p/category-image-medical-instruments__79170.jpg',
				bcId: 41,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05652',
			},
			{
				_id: '66d8b83f6e195ee1d5e05650',
				parentId: 17,
				name: 'Syringes & Needles',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/syringes-needles/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/category-image-midwifery-syringes__74444.jpg',
				bcId: 38,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05650',
			},
			{
				_id: '66d8b83f6e195ee1d5e05643',
				parentId: 17,
				name: 'Education',
				sortOrder: 19,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/education/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/t/category-image-midwifery-books__04062.jpg',
				bcId: 18,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05643',
			},
			{
				_id: '66d8b83f6e195ee1d5e05645',
				parentId: 17,
				name: 'Dopplers',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/dopplers-and-accessories/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/category-image-medical-dopplers__46917.jpg',
				bcId: 20,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05645',
			},
			{
				_id: '66d8b83f6e195ee1d5e0564e',
				parentId: 17,
				name: 'Suturing',
				sortOrder: 12,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/suturing/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/i/category-image-midwifery-suturing__55348.jpg',
				bcId: 35,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0564e',
			},
			{
				_id: '66d8b83f6e195ee1d5e0564f',
				parentId: 17,
				name: 'Urine Strips',
				sortOrder: 7,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/urine-strips/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/z/category-image-midwifery-urine-strips__51820.jpg',
				bcId: 36,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0564f',
			},
			{
				_id: '66d8b83f6e195ee1d5e05669',
				parentId: 17,
				name: 'Stethoscopes ',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/stethoscopes/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/category-image-medical-stethoscopes__70993.jpg',
				bcId: 65,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05669',
			},
			{
				_id: '66d8b83f6e195ee1d5e0566a',
				parentId: 17,
				name: 'Oxygen Equipment',
				sortOrder: 21,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/resuscitation-equipment/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/x/category-image-medical-oxygen-equip__40704.jpg',
				bcId: 66,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0566a',
			},
			{
				_id: '66d8b83f6e195ee1d5e0566b',
				parentId: 17,
				name: 'Blood Pressure Cuffs',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/blood-pressure-cuff/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/n/category-image-medical-blood-pressure-cuffs__79181.jpg',
				bcId: 67,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0566b',
			},
			{
				_id: '66d8b83f6e195ee1d5e0566c',
				parentId: 17,
				name: 'Hemoglobin Analyzers',
				sortOrder: 10,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/hemoglobin-analyzers/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/f/category-image-medical-hemoglobin-analyzers__12039.jpg',
				bcId: 68,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0566c',
			},
			{
				_id: '66d8b83f6e195ee1d5e0566d',
				parentId: 17,
				name: 'Tools, Newborn Slings & Scales',
				sortOrder: 17,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/baby-scales/',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/n/category-image-midwifery-newborn-scales__58899.jpg',
				bcId: 69,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0566d',
			},
			{
				_id: '66d8b83f6e195ee1d5e05670',
				parentId: 17,
				name: 'Masimo Pulse Oximeter',
				sortOrder: 4,
				defaultProductSort: 'price_desc',
				url: {
					path: '/masimo-pulse-oximeter/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/rad%20g__04672.png',
				bcId: 73,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05670',
			},
			{
				_id: '66d8b83f6e195ee1d5e05672',
				parentId: 17,
				name: 'Diagnostics',
				sortOrder: 11,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/diagnostics/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/i/category-image-midwifery-diagnostics__53302.jpg',
				bcId: 75,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05672',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e05682',
		parentId: 0,
		name: 'For Mothers',
		sortOrder: 18,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/mom-baby/',
			isCustomized: true,
		},
		imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/c/category-description-image-mom-baby__13954.jpg',
		bcId: 91,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e05682',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056a4',
				parentId: 91,
				name: 'Pregnancy',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/pregnancy/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/g/pregnancy__56146.jpg',
				bcId: 130,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a4',
			},
			{
				_id: '66d8b83f6e195ee1d5e056a8',
				parentId: 91,
				name: 'Mom Gear',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mom-gear/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/mama%20gear__25577.png',
				bcId: 134,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a8',
			},
			{
				_id: '66d8b83f6e195ee1d5e05691',
				parentId: 91,
				name: 'Breastfeeding',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/breastfeeding/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/f/breastfeeding%20%28new%29__25968.jpg',
				bcId: 107,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05691',
			},
			{
				_id: '66d8b83f6e195ee1d5e0569b',
				parentId: 91,
				name: 'Breast Pumps',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/breast-pumps/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/guest_b7d23e57-d0e3-4e5e-9feb-f5c15a0bcc9f__69282.1621365105.1280.1280_category.jpg',
				bcId: 118,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0569b',
			},
			{
				_id: '66d8b83f6e195ee1d5e05644',
				parentId: 91,
				name: 'For Baby',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/baby-supplies/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/e/category-image-mom-baby-for-baby__86668.jpg',
				bcId: 19,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05644',
			},
			{
				_id: '66d8b83f6e195ee1d5e05683',
				parentId: 91,
				name: 'Mom & Baby Packages',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mom-baby-packages/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/i/category-image-mom-baby-packages__87322.jpg',
				bcId: 93,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05683',
			},
			{
				_id: '66d8b83f6e195ee1d5e05673',
				parentId: 91,
				name: 'Postpartum',
				sortOrder: 2,
				defaultProductSort: 'alpha_asc',
				url: {
					path: '/postpartum/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/l/5__01221.png',
				bcId: 76,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05673',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e05693',
		parentId: 0,
		name: 'Help with...',
		sortOrder: 19,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/help-with/',
			isCustomized: false,
		},
		imageUrl: '',
		bcId: 109,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e05693',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056a6',
				parentId: 109,
				name: 'Postpartum Support',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/postpartum-support/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/f/postpartum%20support%20category__61616.png',
				bcId: 132,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a6',
			},
			{
				_id: '66d8b83f6e195ee1d5e056aa',
				parentId: 109,
				name: 'Pain Management',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/pain-management/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/2__43000.png',
				bcId: 136,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056aa',
			},
			{
				_id: '66d8b83f6e195ee1d5e05697',
				parentId: 109,
				name: 'Energy in pregnancy',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/energy-in-pregnancy/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/j/energy%20in%20pregnancy-2__95083.png',
				bcId: 113,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05697',
			},
			{
				_id: '66d8b83f6e195ee1d5e05694',
				parentId: 109,
				name: 'Breastfeeding',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/breastfeeding-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/a/breastfeeding__95901.png',
				bcId: 110,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05694',
			},
			{
				_id: '66d8b83f6e195ee1d5e05695',
				parentId: 109,
				name: 'Preparing for labor',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/Labor-Prep/',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/x/preparing%20for%20labor__48907.png',
				bcId: 111,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05695',
			},
			{
				_id: '66d8b83f6e195ee1d5e05696',
				parentId: 109,
				name: 'Colic',
				sortOrder: 7,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/colic/',
					isCustomized: true,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/z/new_products_thumbnail__01871.jpg',
				bcId: 112,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e05696',
			},
			{
				_id: '66d8b83f6e195ee1d5e0569c',
				parentId: 109,
				name: 'Hemorrhage prevention',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/hemorrhage-prevention/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/j/hemorrhage_prevention_thumbnail__07239.jpeg',
				bcId: 120,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0569c',
			},
			{
				_id: '66d8b83f6e195ee1d5e0569e',
				parentId: 109,
				name: 'Pregnancy Loss Support',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/pregnancy-loss-support/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/w/pregnancy%20loss%20support-2__71476.png',
				bcId: 123,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0569e',
			},
		],
	},
	{
		_id: '66d8b83f6e195ee1d5e056b9',
		parentId: 0,
		name: 'Brands',
		sortOrder: 20,
		defaultProductSort: 'use_store_settings',
		url: {
			path: '/brands/',
			isCustomized: false,
		},
		imageUrl: '',
		bcId: 151,
		collection: 'categories',
		id: '66d8b83f6e195ee1d5e056b9',
		subcategories: [
			{
				_id: '66d8b83f6e195ee1d5e056a9',
				parentId: 151,
				name: 'Frida Mom',
				sortOrder: 5,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/frida-mom/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/frida__60242.png',
				bcId: 135,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056a9',
			},
			{
				_id: '66d8b83f6e195ee1d5e056b7',
				parentId: 151,
				name: 'The Honey Pot Company',
				sortOrder: 17,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/the-honey-pot-company-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/k/the%20honey%20pot%20company__91189.jpg',
				bcId: 149,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056b7',
			},
			{
				_id: '66d8b83f6e195ee1d5e056ba',
				parentId: 151,
				name: 'Motif Medical',
				sortOrder: 13,
				defaultProductSort: 'alpha_asc',
				url: {
					path: '/motif-medical/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/f/motif%20category%20image__51238.png',
				bcId: 152,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056ba',
			},
			{
				_id: '66d8b83f6e195ee1d5e056c6',
				parentId: 151,
				name: 'Rael',
				sortOrder: 14,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/rael-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/u/rael__80436.jpg',
				bcId: 164,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056c6',
			},
			{
				_id: '66d8b83f6e195ee1d5e0568e',
				parentId: 151,
				name: 'Weleda',
				sortOrder: 18,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/weleda/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/q/weleda__87295.png',
				bcId: 104,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e0568e',
			},
			{
				_id: '670fccd07c43e6934dff3418',
				parentId: 151,
				name: 'Earthley Wellness',
				sortOrder: 4,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earthley-wellness-2/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/a/274068809-287253103476806-5497399683349879988-n__23174.jpg',
				bcId: 184,
				collection: 'categories',
				id: '670fccd07c43e6934dff3418',
			},
			{
				_id: '6888f5cd38b014f310ac352c',
				parentId: 151,
				name: 'Hemocue',
				sortOrder: 9,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/hemocue/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/f/untitled%20design%20%285%29__54562.png',
				bcId: 197,
				collection: 'categories',
				id: '6888f5cd38b014f310ac352c',
			},
			{
				_id: '670ebf1e858a1810195905c3',
				parentId: 151,
				name: 'Dynarex',
				sortOrder: 2,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/dynarex/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/s/dynarex_thumbnail__05880.jpeg',
				bcId: 175,
				collection: 'categories',
				id: '670ebf1e858a1810195905c3',
			},
			{
				_id: '66d8b83f6e195ee1d5e056cd',
				parentId: 151,
				name: 'Birth Pool In A Box',
				sortOrder: 1,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/birth-pool-in-a-box/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/c/mama%20koala%20postpartum%20kit-2__93151.png',
				bcId: 171,
				collection: 'categories',
				id: '66d8b83f6e195ee1d5e056cd',
			},
			{
				_id: '670ebf1e858a1810195905c1',
				parentId: 151,
				name: 'Masimo',
				sortOrder: 10,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/masimo/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/e/2__29224.png',
				bcId: 173,
				collection: 'categories',
				id: '670ebf1e858a1810195905c1',
			},
			{
				_id: '670ebf1e858a1810195905c2',
				parentId: 151,
				name: 'Medline',
				sortOrder: 11,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/medline/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/a/3__02574.png',
				bcId: 174,
				collection: 'categories',
				id: '670ebf1e858a1810195905c2',
			},
			{
				_id: '670ebf1e858a1810195905c4',
				parentId: 151,
				name: 'Oasis',
				sortOrder: 15,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/oasis/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/4__06420.png',
				bcId: 176,
				collection: 'categories',
				id: '670ebf1e858a1810195905c4',
			},
			{
				_id: '670ebf1e858a1810195905c5',
				parentId: 151,
				name: 'Germaine Laboratories',
				sortOrder: 8,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/germaine-laboratories/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/v/5__73434.png',
				bcId: 177,
				collection: 'categories',
				id: '670ebf1e858a1810195905c5',
			},
			{
				_id: '670ebf1e858a1810195905c6',
				parentId: 151,
				name: 'Ethicon',
				sortOrder: 7,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/ethicon/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/o/6__54426.png',
				bcId: 178,
				collection: 'categories',
				id: '670ebf1e858a1810195905c6',
			},
			{
				_id: '670ebf1e858a1810195905c7',
				parentId: 151,
				name: 'Mercury Medical',
				sortOrder: 12,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/mercury-medical/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/i/7__94491.png',
				bcId: 179,
				collection: 'categories',
				id: '670ebf1e858a1810195905c7',
			},
			{
				_id: '670fccd07c43e6934dff3414',
				parentId: 151,
				name: 'Earth Mama',
				sortOrder: 3,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earth-mama-1/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/c/12__20038.png',
				bcId: 180,
				collection: 'categories',
				id: '670fccd07c43e6934dff3414',
			},
			{
				_id: '670fccd07c43e6934dff3415',
				parentId: 151,
				name: 'Wishgarden Herbs',
				sortOrder: 19,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/wishgarden-herbs/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/x/13__74233.png',
				bcId: 181,
				collection: 'categories',
				id: '670fccd07c43e6934dff3415',
			},
			{
				_id: '670fccd07c43e6934dff3416',
				parentId: 151,
				name: 'Earthside Birth Pools',
				sortOrder: 6,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/earthside-birth-pools/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/r/earthside__61034.png',
				bcId: 182,
				collection: 'categories',
				id: '670fccd07c43e6934dff3416',
			},
			{
				_id: '670fccd07c43e6934dff3417',
				parentId: 151,
				name: 'Prestige Medical',
				sortOrder: 16,
				defaultProductSort: 'use_store_settings',
				url: {
					path: '/prestige-medical/',
					isCustomized: false,
				},
				imageUrl: 'https://cdn11.bigcommerce.com/s-nuj3c/product_images/m/11__37285.png',
				bcId: 183,
				collection: 'categories',
				id: '670fccd07c43e6934dff3417',
			},
		],
	},
]
export default function getPlaceholderCategories() {
	return categories
}
